module.exports = __webpack_public_path__ + "media/images/dergavne-7f220e0627c1de9de376c05001386bb0.svg";